export const variants = {
  body8n: {
    fontSize: '0.5rem',
    fontWeight: 'normal',
  },
  body8sb: {
    fontSize: '0.5rem',
    fontWeight: 'semiBold',
  },
  body10n: {
    fontSize: '0.625rem',
    fontWeight: 'normal',
    lineHeight: '1rem',
  },
  body10mute: {
    fontSize: '0.625rem',
    fontWeight: 'normal',
    lineHeight: '1rem',
    color: 'text.blueLabel',
  },
  body10sb: {
    fontSize: '0.625rem',
    fontWeight: 'semiBold',
    lineHeight: '1rem',
  },
  body12m: {
    fontSize: '0.75rem',
    fontWeight: 'medium',
    lineHeight: '1rem',
  },
  body12l: {
    color: 'text.primary',
    lineHeight: '0',
    fontWeight: 'light',
    fontSize: 'xxs',
  },
  body12n: {
    color: 'text.primary',
    lineHeight: '0',
    fontWeight: 'normal',
    fontSize: 'xxs',
  },
  body12mute: {
    color: 'text.blueLabel',
    lineHeight: '0',
    fontWeight: 'normal',
    fontSize: 'xxs',
  },
  body14mute: {
    color: 'text.blueLabel',
    lineHeight: '1.375rem',
    fontWeight: 'normal',
    fontSize: 'sm',
  },
  body12sb: {
    color: 'text.primary',
    lineHeight: '0',
    fontWeight: 'semiBold',
    fontSize: 'xxs',
  },
  body12t: {
    color: 'text.darkBlue',
    lineHeight: '0',
    fontWeight: 'normal',
    fontSize: 'xxs',
  },
  avatar: {
    color: 'text.white',
    lineHeight: '110%',
    fontWeight: 'normal',
    fontSize: 'lg',
  },
  body14n: {
    lineHeight: '1.375rem',
    fontWeight: 'normal',
    fontSize: 'sm',
  },
  body14ls: {
    color: 'text.blueLabel',
    lineHeight: '1.125rem',
    fontWeight: 'normal',
    fontSize: 'sm',
  },
  body14lsp: {
    lineHeight: '1.125rem',
    fontWeight: 'normal',
    fontSize: 'sm',
  },
  body14m: {
    color: 'text.primary',
    lineHeight: '1.375rem',
    fontWeight: 'medium',
    fontSize: 'sm',
  },
  body14ms: {
    color: 'text.primary',
    lineHeight: '1.125',
    fontWeight: 'medium',
    fontSize: 'sm',
  },
  body14sb: {
    color: 'text.primary',
    lineHeight: '1.375rem',
    fontWeight: 'semiBold',
    fontSize: 'sm',
    cursor: 'default',
  },
  body14mb: {
    color: 'text.darkBlue',
    lineHeight: '1.375rem',
    fontWeight: 'semiBold',
    fontSize: 'sm',
    cursor: 'default',
  },
  body14l: {
    color: 'text.primary',
    lineHeight: '1.125rem',
    fontWeight: 'light',
    fontSize: 'sm',
  },
  body14ln: {
    color: 'text.primary',
    lineHeight: '1.125rem',
    fontWeight: 'normal',
    fontSize: 'sm',
  },
  body16l: {
    color: 'text.primary',
    lineHeight: 'md',
    fontWeight: 'light',
    fontSize: 'md',
  },
  body16ls: {
    color: 'text.primary',
    lineHeight: '1.25rem',
    fontWeight: 'normal',
    fontSize: 'md',
  },
  body16m: {
    color: 'text.primary',
    lineHeight: '1.625rem',
    fontWeight: 'medium',
    fontSize: 'md',
  },
  body16n: {
    color: 'text.primary',
    lineHeight: '1.625rem',
    fontWeight: 'normal',
    fontSize: 'md',
  },
  body16sb: {
    color: 'text.primary',
    lineHeight: '1.625rem',
    fontWeight: 'semiBold',
    fontSize: 'md',
  },
  body16b: {
    color: 'text.primary',
    lineHeight: '1.625rem',
    fontWeight: 'bold',
    fontSize: 'md',
  },
  body18n: {
    lineHeight: '1.625rem',
    fontWeight: 'normal',
    fontSize: '1.125rem',
  },
  body18nm: {
    lineHeight: '1.625rem',
    fontWeight: 'medium',
    fontSize: '1.125rem',
  },
  body18sb: {
    lineHeight: '1.625rem',
    fontWeight: 'semiBold',
    fontSize: '1.125rem',
  },
  body18sbn: {
    lineHeight: '1.375rem',
    fontWeight: 'normal',
    fontSize: '1.125rem',
  },
  body18sbl: {
    lineHeight: '1.375rem',
    fontWeight: 'semiBold',
    fontSize: '1.125rem',
  },
  body20n: {
    lineHeight: 'xl',
    fontWeight: 'normal',
    fontSize: 'lg',
  },
  body20nl: {
    lineHeight: '1.5625rem',
    fontWeight: 'normal',
    fontSize: 'lg',
  },
  body20sb: {
    color: 'text.primary',
    lineHeight: 'xl',
    fontWeight: 'semiBold',
    fontSize: 'lg',
  },
  body22l: {
    color: 'text.primary',
    lineHeight: 'xl',
    fontWeight: 'light',
    fontSize: 'xl',
  },
  body22sb: {
    color: 'text.primary',
    lineHeight: '1.375rem',
    fontWeight: 'semiBold',
    fontSize: 'xl',
  },
  body22b: {
    color: 'text.primary',
    lineHeight: 'xl',
    fontWeight: 'bold',
    fontSize: 'xl',
  },
  body24b: {
    color: 'text.primary',
    lineHeight: '1.875rem',
    fontWeight: 'semiBold',
    fontSize: '1.5rem',
  },
  body24n: {
    color: 'text.primary',
    lineHeight: '1.875rem',
    fontWeight: 'normal',
    fontSize: '1.5rem',
  },
  body26sb: {
    color: 'text.primary',
    lineHeight: '1rem',
    fontWeight: 'semiBold',
    fontSize: 'xl',
  },
  body28n: {
    fontSize: '1.75rem',
    fontWeight: 'regular',
    lineHeight: '1.875rem',
  },
  body28sb: {
    fontSize: '1.75rem',
    fontWeight: 'semiBold',
    lineHeight: '1.875rem',
  },
  body28b: {
    fontSize: '1.75rem',
    fontWeight: 'bold',
    lineHeight: '1.875rem',
  },
  body30sb: {
    fontSize: '1.875rem',
    fontWeight: 'semiBold',
    lineHeight: '1.875rem',
  },
  body45sb: {
    fontSize: '2.8125rem',
    fontWeight: 'semiBold',
    lineHeight: '3.5rem',
    color: 'text.primary',
  },
}
